import { render, staticRenderFns } from "./ParametrosSistema.vue?vue&type=template&id=998afa2a&"
import script from "./ParametrosSistema.vue?vue&type=script&lang=js&"
export * from "./ParametrosSistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ParametrosSistema.vue"
export default component.exports